import { Link } from "react-router-dom";
import { STATUS } from "@/lib/format";

export const BrandLogo = ({ to = "/", className = "", dark = false }) => (
  <Link to={to} className={`flex items-center gap-3 ${className}`} data-testid="brand-logo-link">
    <span className={`rounded-lg px-2.5 py-1.5 ${dark ? "" : "bg-[#1A2B3C]"}`}>
      <img src="/brand/logo.png" alt="Madonna Store" className="h-5 w-auto" />
    </span>
  </Link>
);

export const StatusBadge = ({ status, testid }) => {
  const { label, cls } = STATUS[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}>
      {label}
    </span>
  );
};

export const AckBadge = ({ job, testid }) => {
  if (!job?.tech_ack) return null;
  const d = (s) => (s ? new Date(`${s}T12:00:00`).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" }) : "");
  const [label, cls] = job.tech_ack === "in_attesa" ? ["Tecnico esterno: attende conferma", "bg-amber-50 text-amber-800 border-amber-200"]
    : job.tech_ack === "rifiutato" ? [`Rifiutato${job.ack_rejected_by ? ` da ${job.ack_rejected_by}` : ""}${job.ack_note ? `: ${job.ack_note}` : ""} · da riassegnare`, "bg-red-50 text-red-700 border-red-200"]
    : job.ack_moved ? [`Accettato con nuova data proposta: ${d(job.date)} ${job.start}`, "bg-sky-50 text-sky-800 border-sky-200"]
    : ["Confermato dal tecnico esterno", "bg-emerald-50 text-emerald-800 border-emerald-200"];
  return <span data-testid={testid} className={`mt-1 inline-flex w-fit items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold ${cls}`}>{label}</span>;
};

export const SectionLabel = ({ children }) => (
  <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-slate-500">{children}</p>
);
